import ShopCheckoutOrderModelBase from '../_generated/modelBases/shop-checkout-order-model-base';

export default class ShopCheckoutOrderModel extends ShopCheckoutOrderModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
